<template>
  <div class="animated fadeIn">
        <b-card>
            <div slot="header">
                Master Item Form
              <div class="card-header-actions">
                <button v-if="saveEnabled" class="btn btn-primary mr-1" @click.stop="save()">
                  <i class="fa fa-save"></i> Save
                </button>
                <b-button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</b-button>
              </div>
            </div>

              <b-row>
                <b-col lg="7">
                    <b-row>
                      <b-col lg="8">
                        <b-input-group >
                          <b-input-group-prepend><label>Item Code (P/N)</label></b-input-group-prepend>
                            <b-form-input v-model="model.partnumber" placeholder="Code / Part Number" v-b-tooltip.hover title="International Code: Part Number" ></b-form-input>
                              <b-form-radio-group class="mt-2" v-model="model.jasa" name="radioJasa">
                            <b-form-radio value="0">Material</b-form-radio>
                            <b-form-radio value="1">Service</b-form-radio>
                              </b-form-radio-group>
                        </b-input-group >
                      </b-col>
                      <b-col lg="4" class="text-right">                            
                          <b-form-checkbox  class="ml-1 mt-2" v-model="model.isactive" value=0 unchecked-value=1>
                              In Active/Discontinued
                          </b-form-checkbox>
                      </b-col>
                    </b-row>
                    <b-input-group >
                        <b-input-group-prepend><label>Item Name</label></b-input-group-prepend>
                          <b-form-input v-model="model.itemname" :state="!$v.model.itemname.$error" ></b-form-input>
                    </b-input-group>
                    <b-input-group >
                          <b-input-group-prepend><label>PURCHASE UnitSize</label></b-input-group-prepend>
                            <b-form-input v-model="model.unitsize" :state="!$v.model.unitsize.$error"></b-form-input>
                        <b-input-group-prepend><label class="text-right" style="width:190px;">Convert INVENTORY UnitSize</label></b-input-group-prepend>
                            <b-form-input v-model="model.qtykonversi" class="mr-1" placeholder="Qty Conversion" type="number" min="1" v-b-tooltip.hover title="QTY Conversion Purchase to Inventory Unitsize"></b-form-input>
                            <b-form-input v-model="model.invunitom" :state="!$v.model.invunitom.$error"></b-form-input>
                    </b-input-group>
                </b-col>
                <b-col lg="5">
                      <b-input-group >
                          <b-input-group-prepend><label>Item Category</label></b-input-group-prepend>
                        <b-form-select v-model="model.itemcategory" :plain="true" :options="itemCategories" :state="!$v.model.itemcategory.$error"></b-form-select>
                            <b-input-group-prepend><label class="text-right" style="width:85px !important;">Head Cat.</label></b-input-group-prepend>
                            <b-form-select v-model="model.headcategory" :plain="true" :options="headCategories" :state="!$v.model.headcategory.$error"></b-form-select>
                      </b-input-group>
                    <!-- <b-row>
                      <b-col lg="6">
                          <b-input-group >
                              <b-input-group-prepend><label>Item Category</label></b-input-group-prepend>
                            <b-form-select v-model="model.itemcategory" :plain="true" :options="itemCategories" :state="!$v.model.itemcategory.$error"></b-form-select>
                          </b-input-group>
                      </b-col>
                      <b-col lg="6">                            
                        <b-input-group >
                            <b-input-group-prepend><label class="text-right">Head Category</label></b-input-group-prepend>
                            <b-form-select v-model="model.headcategory" :plain="true" :options="headCategories" :state="!$v.model.headcategory.$error"></b-form-select>
                        </b-input-group>
                      </b-col>
                    </b-row>        -->

                    <b-input-group>
                      <b-input-group-prepend><label>Item Usage-Type </label></b-input-group-prepend>
                        <div style="flex: 1 1 auto;width: 1%;" >
                          <b-form-radio-group class="mt-2" v-model="model.itemUsageType" name="radioLabel">
                            <b-form-radio :value="'FIXED ASSET'">FIXED ASSET</b-form-radio>
                            <b-form-radio :value="'REUSEABLE'"   v-b-tooltip.hover title="Inventory Label">REUSEABLE</b-form-radio>
                            <b-form-radio :value="'CONSUMABLE'">CONSUMABLE </b-form-radio>
                          </b-form-radio-group>
                        </div>
                    </b-input-group>          
                      <b-input-group v-if="(model.itemUsageType=='FIXED ASSET')">
                          <b-input-group-prepend><label>Fix.Asset Cat.</label></b-input-group-prepend>
                        <b-form-select v-model="model.fixasset_catgid" :plain="true" :options="fixasset_cats" :state="!$v.model.fixasset_catgid.$error"></b-form-select>
                      </b-input-group>

                    <!-- <b-form-group label-cols=3 label="Alternatif Item Code" breakpoint="md" >
                        <b-row no-gutters>
                          <b-col xl="6">
                            <b-input-group >
                                <b-form-input readonly v-model="model.alteritemcode"></b-form-input>
                                <b-input-group-append>
                                <b-btn text="Button" @click="lkuItemShow=true" >
                                    <i class="fa fa-search"></i>
                                </b-btn>
                                </b-input-group-append>
                            </b-input-group>
                          </b-col>
                        </b-row>                      
                    </b-form-group>  
                    <b-form-group label-cols=3 label="Alternatif Item Name"  breakpoint="md" >
                        <b-row no-gutter>
                          <b-col>
                                <b-form-input disabled v-model="model.alteritemname" placeholder="Alternatif Item Name"></b-form-input>
                          </b-col>
                        </b-row>                      
                    </b-form-group>   -->

                    <b-input-group >
                        <b-input-group-prepend><label style="width:305px !important">Toleransi kelebihan/kekurangan saat Receiving</label></b-input-group-prepend>
                        <b-form-input v-model="model.toleransi" type="number"></b-form-input>
                        <b-input-group-append><span class="input-group-text">{{model.invunitom}}</span></b-input-group-append>
                    </b-input-group>

                </b-col>
              </b-row>
              <b-card no-body class="mt-2">
                <b-tabs card>
                  <b-tab title="Inventory">
                      <b-row>
                        <b-col lg="6">
                                <b-row no-gutters>
                                    <b-col lg="5">
                                      <b-input-group >
                                          <b-input-group-prepend><label style="width:130px !important">Inventory Item</label></b-input-group-prepend>
                                          <b-form-select v-model="model.inventory" :plain="true" :options="dataList.YesNo" ></b-form-select>
                                      </b-input-group>
                                    </b-col>
                                  <b-col lg="7">
                                      <b-input-group >
                                          <b-input-group-prepend class="d-md-inline d-lg-none"><label>&nbsp;</label></b-input-group-prepend>
                                          <b-form-checkbox  class="ml-1 mt-2" v-model="model.qtyUndefined" value=1 unchecked-value=0>
                                                Inventory Value (Not Quantity)
                                          </b-form-checkbox>
                                      </b-input-group>
                                  </b-col>
                                </b-row>
                                <b-input-group >
                                    <b-input-group-prepend><label>Inventory Category</label></b-input-group-prepend>
                                  <b-form-select v-model="model.inven_catid" :plain="true" :options="inventory_cats" :state="!$v.model.inven_catid.$error"></b-form-select>
                                </b-input-group>
                                <b-row>
                                    <b-col lg="6">
                                        <b-input-group>
                                            <b-input-group-prepend><label style="width:130px !important">Minimum Stock</label></b-input-group-prepend>
                                            <b-form-input v-model="model.reorderpoint" type="number" placeholder="reorder point"></b-form-input>
                                            <b-input-group-append><span class="input-group-text">{{model.invunitom}}</span></b-input-group-append>
                                        </b-input-group>
                                    </b-col>
                                    <b-col lg="6">
                                        <b-input-group >
                                            <b-input-group-prepend><label style="width:130px !important">Reorder Quantity</label></b-input-group-prepend>
                                            <b-form-input v-model="model.reorderqty" type="number"></b-form-input>
                                            <b-input-group-append><span class="input-group-text">{{model.invunitom}}</span></b-input-group-append>
                                        </b-input-group>
                                    </b-col>
                                </b-row>      
                        </b-col>
                        <b-col lg="6">
                                <b-row align-h="end">
                                    <b-col md="6" lg="5" xl="4">
                                      <b-input-group >
                                          <b-form-checkbox  class="mt-2" v-model="model.ishasserialno" value=1 unchecked-value=0>
                                                Has Serial Number
                                          </b-form-checkbox>
                                      </b-input-group>
                                      <b-input-group >
                                          <b-form-checkbox  class="mt-2" v-model="model.isrepairable" value=1 unchecked-value=0>
                                                Repairable Item/Part
                                          </b-form-checkbox>
                                      </b-input-group>
                                          <b-form-checkbox  class="mt-2" v-model="model.isexpireable" value=1 unchecked-value=0>
                                                Has Expired Date
                                          </b-form-checkbox>
                                    </b-col>
                                    <b-col md="6" lg="5" xl="4">
                                      <b-input-group >
                                          <b-form-checkbox  class="mt-2" v-model="model.isusegcif" value=1 unchecked-value=0>
                                                Inspection on Receiving
                                          </b-form-checkbox>
                                      </b-input-group>
                                      <b-input-group >
                                          <b-form-checkbox  class="mt-2" v-model="model.salespostgrp" value=1 unchecked-value=0>
                                                Item untuk dijual
                                          </b-form-checkbox>
                                      </b-input-group>
                                      <b-input-group >
                                          <b-form-checkbox  class="mt-2" v-model="model.konsinyasi" value=1 unchecked-value=0>
                                                Konsinyasi Item
                                          </b-form-checkbox>
                                      </b-input-group>
                                    </b-col>
                                </b-row>                      
                        </b-col>
                      </b-row>
                  </b-tab>
                  <b-tab title="Vendor/Supplier">
                    <b-table
                        class="mb-0"
                        ref="tblVendor"
                        outlined
                        striped hover small 
                        style="font-size:smaller;"
                        :items="vendor.list"
                        :fields="vendor.fields"
                        :current-page="vendor.page"
                        :per-page="vendor.limit"
                      >
                          <template v-slot:cell(index)="data">
                            {{data.index + 1}}
                          </template>

                          <template v-slot:cell(action)="data">
                            <div class="text-center">
                            <a href="javascript:void(0)" class="text-danger" @click="delVendor(data.index)">
                              <i class="fa fa-trash"></i>
                            </a>
                            </div>
                        </template>
                    </b-table>
                    <b-row>
                      <b-col cols="6">
                        <b-row>
                        <b-button size="sm" class="btn btn-primary ml-3" @click="addVendor" >Add Supplier/vendor</b-button>                          
                        <div class="ml-2">
                          Showing
                          {{(vendor.page - 1) * vendor.limit + 1}}
                          to
                          {{vendor.page * vendor.limit}}
                          of
                          {{vendor.total}}
                          entries
                        </div>    
                        </b-row>                    
                      </b-col>
                      <b-col cols="6">
                        <b-pagination
                          align="right"
                          :total-rows="vendor.total"
                          :per-page="vendor.limit"
                          v-model="vendor.page"
                        ></b-pagination>
                      </b-col>
                    </b-row>

                  </b-tab>
                  <b-tab title="Group/Classification">
                    <b-table
                        class="mb-0"
                        ref="tblGroup"
                        outlined
                        striped hover small 
                        style="font-size:smaller;"
                        :items="group.list"
                        :fields="group.fields"
                        :current-page="group.page"
                        :per-page="group.limit"
                      >
                          <template v-slot:cell(index)="data">
                            {{data.index + 1}}
                          </template>

                          <template v-slot:cell(action)="data">
                            <div class="text-center">
                            <a href="javascript:void(0)" class="text-danger" @click="delGroup(data.index)">
                              <i class="fa fa-trash"></i>
                            </a>
                            </div>
                        </template>
                    </b-table>
                    <b-row>
                      <b-col cols="6">
                        <b-row>
                        <b-button size="sm" class="btn btn-primary ml-3" @click="addGroup" >Add Group</b-button>                          
                        <div class="ml-2">
                          Showing
                          {{(group.page - 1) * group.limit + 1}}
                          to
                          {{group.page * group.limit}}
                          of
                          {{group.total}}
                          entries
                        </div>    
                        </b-row>                    
                      </b-col>
                      <b-col cols="6">
                        <b-pagination
                          align="right"
                          :total-rows="group.total"
                          :per-page="group.limit"
                          v-model="group.page"
                        ></b-pagination>
                      </b-col>
                    </b-row>
                  </b-tab>

                </b-tabs>
              </b-card>    

            <b-row class="justify-content-center mb-2">
                <button  v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
                <b-button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</b-button>
            </b-row>
    </b-card>
        <b-modal v-model="lkuVendorShow" size="lg" :hide-footer="true" title="List of Vendor" :centered="true">
            <lku-vendor @click="onSelectLkuVendor"></lku-vendor>
        </b-modal>        
        <b-modal v-model="lkuGroupShow" size="lg" :hide-footer="true" title="List of Item Grouping" :centered="true">
            <lku-itemgroup @click="onSelectLkuGroup"></lku-itemgroup>
        </b-modal>        
  </div>
</template>

<script>
import item from "../../apis/item";
import fixedasset from '../../apis/fixedasset';
import { validationMixin } from "vuelidate";
import { required, requiredIf, numeric } from "vuelidate/lib/validators";
import lkuItemgroup from "../lookup/lkuItemGroup";
import lkuVendor from "../lookup/lkuVendor";
import dropdown from "../../data/dropdown";
import toastr from "mini-toastr";
toastr.init();

export default {   
  components:{lkuItemgroup,lkuVendor},
  mixins: [validationMixin],
  validations: {
        model: {
            itemname: { required },
            itemcategory: { required },
            headcategory: { required },
            invunitom: { required:requiredIf('inventory') },
            unitsize: { required },
            itemUsageType: { required },
            fixasset_catgid: {required : (function() {
                if (this.model.itemUsageType!='FIXED ASSET') {
                    return true;
                } else if (!(this.model.fixasset_catgid)) {
                    return false;
                } else return true;
            })},
            inven_catid: {required : (function() {
                if (this.model.inventory != 1) {
                    return true;
                } else if (!(this.model.inven_catid)) {
                    return false;
                } else return true;
            })},
        },
    vendor: {
        obj: {
            itemno: { required },
            vendor_code: { required },
        }
    },
    group: {
        obj: {
            itemno: { required },
            group_name: { required },
        }
    },
  }, 
  data () {
    return {
        saveEnabled:true,
        dataList: {
          YesNo: dropdown.YesNo
        },      
        model: {
            itemno: '',partnumber: '',
            itemname: '',
            itemcategory: '',
            headcategory: '',
            itemUsageType: 'CONSUMABLE',
            fixasset_catgid:'',inven_catid:'',
            inventory: '0',qtykonversi:1,
            invunitom: 'UNIT',
            unitsize: 'UNIT',
            reorderpoint:0,reorderqty:0,
            compcode:this.$store.state.user.compcode,
        },
        vendor: {
            list: [],
            obj:{vendor_code:'', itemno:''},
            fields: [
                {key: 'index', label: 'No.' ,thStyle: "width:40px"},
                {
                    key: "vendorinfo",
                    label: "Vendor/Supplier Name"
                },
                {
                    key: "vendor_address",
                    label: "Address"
                },
                {
                    key: "vendor_phone",
                    label: "Phone",
                },
                {
                    key: "vendor_fax",
                    label: "Fax.",
                },
                {
                    key: "action",
                    label: "Action",
                    thStyle: "width:60px",
                    thClass: "text-center",
                },
            ],
            page: 1,
            limit: 6,
            total: 0,
        },
        lkuVendorShow:false,
        lkuGroupShow:false,
        group: {
            list: [],
            selected:{},
            obj:{group_name:'', itemno:''},
            fields: [
                {key: 'index', label: 'No.' ,thStyle: "width:40px"},
                {
                    key: "kodegroup",
                    label: "Group Code"
                },
                {
                    key: "namagroup",
                    label: "Group Name"
                },
            ],
            page: 1,
            limit: 6,
            total: 0,
        },
        currency:[{value:'IDR',text:'IDR'}],
        headCategories:[],itemCategories:[],
        fixasset_cats:[], inventory_cats:[]
    }
  },
  computed: {
      invalidModel() {
        this.$v.model.$touch();
        return this.$v.model.$invalid;
      },
      inventory() {
          return this.model.inventory;
      },

  },
  created: async function(){
      if (this.$route.params.itemno)  {
          toastr.info('Loading Item Detail, please wait')
          try {
            // const data = await item.detail(this.$route.params);  
            const [a,b,data,fa_cats,inv_cats] = await Promise.all([item.headgroup(),item.group(),item.detail(this.$route.params),fixedasset.category(),item.inventorygroup()]) ;
            this.headCategories = a; 
            this.itemCategories = b; 
            this.fixasset_cats=fa_cats;
            this.inventory_cats=inv_cats;

            const row = data[0];
            for (var key in row) {
                this.model[key] = row[key];
            }
            this.group.list = data[1];
            this.vendor.list = data[2];
            this.$forceUpdate();
            toastr.clear;
          } catch (error) {
              console.log('error : ', error);
              toastr.error(JSON.stringify(error), "ERROR MESSAGE",10000);                              
          }
      } else {
        const [a,b,fa_cats,inv_cats] = await Promise.all([item.headgroup(),item.group(),fixedasset.category(),item.inventorygroup()]) ;
        this.headCategories = a; 
        this.itemCategories = b; 
        this.fixasset_cats=fa_cats;
        this.inventory_cats=inv_cats;
        this.model.itemno='';
      }

  },
  methods:{
    addGroup : function () {
        this.lkuGroupShow=true;
    },
    delGroup: function (index) {
        if (index > -1) {
        this.group.list.splice(index, 1);
        }
        this.group.total=this.group.list.length;
    },
    addVendor : function () {
        this.lkuVendorShow=true;
    },
    delVendor: function (index) {
        if (index > -1) {
        this.vendor.list.splice(index, 1);
        }
        this.vendor.total=this.vendor.list.length;
    },
    onSelectLkuGroup: function (_selected) {
        const obj={
                  idgroup : _selected.idgroup,
                  kodegroup : _selected.kodegroup,
                  namagroup : _selected.namagroup,
                  }
        this.group.list.push(obj);
        this.group.total=this.group.list.length;
        this.lkuGroupShow=false;
    },
    onSelectLkuVendor: function (_selected) {
        const obj={
                  vendorinfo : _selected.vendor_name.trim() + ' | ' + _selected.vendor_code.trim(),
                  vendor_code : _selected.vendor_code,
                  vendor_address : `${_selected.vendor_address1} ${_selected.vendor_address2} ${_selected.vendor_city}`,
                  vendor_city : _selected.vendor_city,
                  vendor_phone: _selected.vendor_phone,
                  vendor_fax: _selected.vendor_fax,
                  idvendor : _selected.vendor_id
                  }
        this.vendor.list.push(obj);
        this.vendor.total=this.vendor.list.length;
        // console.log('this.vendor.list : ',this.vendor.list);
        // this.$refs.tblVendor.refresh();
        this.lkuVendorShow=false;
    },

    save: async function(){
        if (!this.saveEnabled) {
            return;
        }
        this.saveEnabled=false;            
        // this.model.npwp_name = this.model.npwp_name || this.model.itemname;
        // this.model.npwp_address1 = this.model.npwp_address1 || this.model.item_address1 ;
        // this.model.npwp_address2 = this.model.npwp_address2 || this.model.item_address2;
        // this.model.npwp_city = this.model.npwp_city || this.model.item_city;
        if (this.invalidModel) {
                const invalidobj={};
                for (var key in this.$v.model) {
                if (this.$v.model[key].$anyError) {
                    if (this.$v.model[key].$anyError==true) invalidobj[key] = this.$v.model[key];
                }
                }        
                console.log('validation model: ', this.model);
                console.log('validation field: ', invalidobj);
                toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
            this.saveEnabled=true;            
       } else {
            try {
              const data={};
              for (var key in this.model) {
                  data[key] = this.model[key];
              }
              data.invlabel= (data.itemUsageType =='REUSABLE') ? 1:0;

              data.groups = this.group.list.reduce((newArr, item) => {
                  if ((item.group_name || '') != '')
                  {
                      newArr.push(item);
                  }
                  return newArr;
              }, []);
              data.vendors = this.vendor.list.reduce((newArr, item) => {
                  newArr.push(item);
                  return newArr;
              }, []);
              await item.save(data);
              this.close();
          } catch (error) {
              this.saveEnabled=true;
              // this.isLoading=false;
              if (error.sql) {
                  toastr.error(error.sql,'ERROR MESSAGE',10000);
              } else if (error.sqlMessage) {
                  toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
              } else if (error.message) {
                  toastr.error(error.message,'ERROR MESSAGE',10000);
              } else {
                  toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
              }        
          }
        }
    },
    close(){
      const routeAsal = localStorage.getItem('itemRoute') || "procurement.item";
      router.push({name:routeAsal});
    },    

  }
}
</script>